import React from 'react';
import useResponsive from '../hooks/useResponsive';

const ResponsiveTabs = ({ 
  tabs = [], 
  value, 
  onChange, 
  children,
  className = '' 
}) => {
  const { isMobile, isTablet } = useResponsive();

  return (
    <div className={`responsive-tabs ${className}`}>
      <div className="tabs-container">
        
          <div className="desktop-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.value}
                className={`tab-button ${value === tab.value ? 'active' : ''}`}
                onClick={(e) => onChange(e, tab.value)}
              >
                {tab.label}
              </button>
            ))}
          </div>
      </div>

      {/* Tab Content */}
      {children && (
        <div className="tab-content">
          {children}
        </div>
      )}
    </div>
  );
};

export default ResponsiveTabs;

